<template>
  <div>
    <div>
     <img
        src="../assets/lamp.svg"
        alt="info"
        height="300vh"/>
    </div>

    <div>
      <p>{{ $t(question) }}</p>
    </div>

    <div @click="goToSurveyForm()">
      <app-button-rect></app-button-rect>
    </div>

  </div>
</template>

<script>
import ButtonRect from './ButtonRect.vue';

export default {
  name: 'survey-init',
  components: {
    'app-button-rect': ButtonRect,
  },
  props: {
    question: {
      type: String,
      default: 'defaultQuestion',
    },
  },
  data() {
    return {
      msg: 'Hi there!',
    };
  },
  methods: {
    goToSurveyForm() {
      this.$router.push({ path: '/surveyform' });
    },
  },
};
</script>

<style scoped>
</style>
